import React from "react";
import { useAccessControl } from "../../../app/access-control-context";
import { useSkills } from "../../../hooks/use-skills";

import { SkillsAccordion, SkillsAccordionProps } from "../../accordion/skills-accordion";
import * as Permissions from "../../../data/permissions";

export interface SkillProps {
  staffMemberId: string;
}

export const Skills: React.FC<SkillProps> = ({ staffMemberId }) => {
  const { activeCenterId, hasPermission, profile } = useAccessControl();

  const { skills, updateSingleSkillMutator } = useSkills(activeCenterId, staffMemberId);

  const isEditingSelf = profile?.id === staffMemberId;
  const hasStaffEditPermission = !!hasPermission?.(Permissions.STAFF_EDIT);
  const canEdit = !isEditingSelf && hasStaffEditPermission;

  const handleSelectSkill: SkillsAccordionProps["onSelectSkill"] = (skill, field, value) => {
    updateSingleSkillMutator.mutate({
      ...skill,
      [field]: value
    });
  };

  return (
    <>
      <SkillsAccordion skillGroups={skills} readOnly={!canEdit} onSelectSkill={handleSelectSkill} />
    </>
  );
};
